// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityData } from '@lfx/key-projects/key-projects.model';
import { SharedModule } from '@lfx/shared/shared.module';

@Component({
  selector: 'lfx-activity-column',
  imports: [CommonModule, SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="activity-container">
      <div class="activity-chart">
        <lfx-line-echarts
          [sparkline]="true"
          [sparklineData]="chartDataWithFallback()"
        >
        </lfx-line-echarts>
      </div>
      <div class="activity-stats">
        <span class="trend-indicator">
          <i [class]="trendIcon()" [style.color]="trendColor()"></i>
          <span class="percentage-text lf-body-xs"
            >{{ activity().changePercentage }}%</span
          >
        </span>
        <span class="trend-period lf-body-xs">vs. last period</span>
      </div>
    </div>
  `,
  styleUrls: ['./activity-column.component.scss'],
})
export class ActivityColumnComponent {
  readonly activity = input.required<ActivityData>();

  protected readonly ariaLabel = computed(
    () => `Activity chart showing ${this.activity().trend} trend`
  );

  protected readonly trendIcon = computed(() =>
    this.activity().trend === 'up'
      ? 'fas fa-arrow-circle-up'
      : 'fas fa-arrow-circle-down'
  );

  protected readonly trendColor = computed(() =>
    this.activity().trend === 'up' ? '#10B981' : '#EF4444'
  );

  protected readonly chartDataWithFallback = computed(() => {
    const chartData = this.activity().chartData;

    if (chartData && chartData.length > 0) {
      return chartData;
    }

    // Fallback to constant flat line when no data
    return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  });
}
